const React = require('react'),
    {PropTypes} = require('react');

const PaginationItem = React.createClass({displayName: "PaginationItem",
    propType: {
        pageNumber: PropTypes.number,
        isActive: PropTypes.bool,
        onClick: PropTypes.function
    },

    render() {
        let className = 'pagination-item';

        if (this.props.isActive) {
            className += ' is-active';
        }

        return (
            React.createElement("div", {onClick: this.props.onClick, className: className}, this.props.pageNumber)
        );
    }
});

module.exports = PaginationItem;



/** WEBPACK FOOTER **
 ** ./src/components/Commons/Pagination/PaginationItem/PaginationItem.js
 **/